import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

// Wholesale-set the per-item tour-operator assignment list (the footer "remove"
// action computes the new id list and calls this). Lives in the itineraries
// domain — both the operations list and the planner read the item, so refresh
// both (and the operator-assignments view) on settle.
export const useSetTourOperators = () => {
  const utils = trpc.useUtils();
  return trpc.itineraryItems.setTourOperators.useMutation({
    onSettled: () => {
      invalidateItemQueries(utils);
      utils.operations.tourOperatorAssignments.invalidate();
    },
  });
};
